import React from 'react'
import { IStoreState, useAppDispatch, useAppSelector } from '../../../redux';
import { fetchDashboardExpenseCatgoriesAsync } from '../../../redux/analytics/analytics.actions';
import { BankingExpensesCategories } from './banking-expenses-categories';
import { Iconify } from '../components/iconify';
import { useOutletContext } from '../../../providers';

export const ExpenseCategories = () => {
const {  outlet_details: { outlet_uuid } } = useOutletContext()

    const {
        data: expense_categories_list,
        loading,
        totalRecords,
        overview
    } = useAppSelector((storeState: IStoreState) => storeState.analytics.expense_categories_list);
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        if(outlet_uuid)
        dispatch(
            fetchDashboardExpenseCatgoriesAsync(outlet_uuid),
        );

        // return () => {
        //   dispatch(clearOrdersStateSync());
        // };
    }, [outlet_uuid]);

    return (
        <BankingExpensesCategories
            title="Expenses categories"
            overview={overview}
            chart={{
                series: expense_categories_list.map((item) => ({ label: item.category, value: item.amount })),
                icons: [
                    <Iconify icon="streamline:dices-entertainment-gaming-dices-solid" />,
                    <Iconify icon="maki:fuel" />,
                ],
            }}
        />

    )
}
